<template>
  <v-container fluid>
      <!-- {{ file }} -->
    <v-stepper v-model="step" vertical>
      <v-stepper-step step="1" :complete="step > 1">Name your audience</v-stepper-step>
      <v-stepper-content step="1">
        <step-one @setName="setName" :name="name"></step-one>
        <v-btn text @click="cancelStepper">Cancel</v-btn>
        <v-btn color="primary" @click.native="step = 2" :disabled="!name">Continue</v-btn>
      </v-stepper-content>
      <v-stepper-step step="2" :complete="step > 2">Upload your file</v-stepper-step>
      <v-stepper-content step="2">
        <step-two @input="setFile"></step-two>
        <v-btn text @click.native="step = 1">Cancel</v-btn>
        <v-btn color="primary" @click.native="step = 3" :disabled="!items.length">Continue</v-btn>
      </v-stepper-content>
      <v-stepper-step step="3" :complete="step >3">Preview file</v-stepper-step>
      <v-stepper-content step="3">
        <step-three :headers="headers" :items="items"></step-three>
        <v-btn text @click.native="step = 2">Cancel</v-btn>
        <v-btn color="primary" @click.native="step = 4">Continue</v-btn>
      </v-stepper-content>
      <v-stepper-step step="4">Confirm agreement to terms</v-stepper-step>
      <v-stepper-content step="4">
        <step-four @setTerms="setTerms"></step-four>
        <v-btn text @click.native="step = 3">Cancel</v-btn>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click.native="submit"
              color="primary"
              :disabled="setupMode || !terms" @click="showAudiencesTable"
            >
              Continue
            </v-btn>
          </template>
          <span v-if="setupMode">Disabled in setup mode</span>
        </v-tooltip>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import { sha256 } from 'js-sha256'
import StepOne from './StepOne.vue'
import StepTwo from './StepTwo.vue'
import StepThree from './StepThree.vue'
import StepFour from './StepFour.vue'
export default {
  components: {
    StepFour,
    StepThree,
    StepTwo,
    StepOne},
  data () {
    return {
      step: 1,
      name: '',
      file: {},
      headers: [],
      items: [],
      terms: false
    }
  },
  computed: {
    setupMode () {
      const setupMode = this.$store.getters.getSetupMode
      return setupMode ? setupMode.status : false
    }
  },
  methods: {
    setName (val) {
      this.name = val
    },
    setFile (file, parsedFile) {
      this.file = file
      if (typeof parsedFile.data[0] !== typeof []) {
        this.$store.dispatch('showNotification', {
          type: 'warning',
          message: ['File is empty. Please choose another file']
        })
        this.headers = []
        this.items = []
        return false
      }
      parsedFile.data[0].forEach((item) => this.headers.push(item))
      for (let i = 1; i <= 5; i++) {
        let arr = []
        if (typeof parsedFile.data[i] === typeof []) {
          parsedFile.data[i].forEach((header, index) => {
            arr.push(parsedFile.data[i][index])
          })
          this.items.push(arr)
        } else {
          this.headers = []
          this.items = []
          this.$store.dispatch('showNotification', {
            type: 'warning',
            message: ['File is empty. Please choose another file']
          })
        }
      }
    },
    setTerms (valid) {
      this.terms = valid
    },
    showAudiencesTable () {
      if (this.terms) this.$emit('showAudiencesTable')
    },
    cancelStepper () {
      this.$emit('cancelStepper')
    },
    submit () {
      let data = []
      this.items.forEach(item => {
        let string = ''
        string += item[0]
        data.push(sha256(string))
      })
      const file = {
        meta: {
          name: this.name,
          uploadDate: this.$moment(),
          status: 'processing',
          size: this.file.size
        },
        timestamp: this.$moment().unix(),
        payload: {
          schema: 'EMAIL_SHA256',
          data
        }
      }
      this.$emit('addFile', file)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
